import { render, staticRenderFns } from "./favorite.vue?vue&type=template&id=07c5f42a"
import script from "./favorite.vue?vue&type=script&lang=js"
export * from "./favorite.vue?vue&type=script&lang=js"
import style0 from "./favorite.vue?vue&type=style&index=0&id=07c5f42a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports